import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import questionReducer from "./slices/questionSlice";
import userReducer from "./slices/userSlice";
import answerCodeReducer from "./slices/answerCodeSlice";
import questionDesignReducer from "./slices/questionDesignSlice";
import ubaTokenReducer from "./slices/ubaTokenSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "ubaToken"],
};

const rootReducer = combineReducers({
  question: questionReducer,
  user: userReducer,
  answerCode: answerCodeReducer,
  questionDesign: questionDesignReducer,
  ubaToken: ubaTokenReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
